import { Link } from 'react-router-dom';
import { HandHeart } from '@phosphor-icons/react';

export default function CreditsChip() {
  return (
    <Link
      to="/credits"
      data-testid="bless-chip"
      className="inline-flex items-center gap-1.5 border border-amber-500/50 bg-amber-500/10 px-2.5 py-1.5 text-[10px] uppercase tracking-[0.22em] text-amber-300 hover:bg-amber-500/20"
    >
      <HandHeart weight="fill" className="h-3.5 w-3.5" /> bless
    </Link>
  );
}
